import { lazy, type LazyExoticComponent } from 'react';

import type { PredicateRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const ResumptionRendererAsync: LazyExoticComponent<
	(props: PredicateRendererFor<'resumption'>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/resumption-ui" */ './ResumptionRenderer'
	).then((m) => ({ default: m.ResumptionRenderer })),
);
